module.exports = __webpack_public_path__ + "img/customization.0775e225.png";